export default __webpack_public_path__ + "assets/images/coins-4a38af34390dc8f1082a8316a17c2cbd.svg";